import React, {useEffect, useMemo} from 'react';
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {
    selectCategoriesNews,
    selectCategory,
    selectDataNews,
    selectDateNews,
    selectMpsNews,
    selectPageNews,
    selectSpmNews
} from "../../common/selectors";
import {fetchDataNewsTC, fetchParamNewsTC} from "../../redux/newsReducer";
import {Table, Tooltip} from "antd";
import {lightColor, marketPlacesColors, superMarketsColors} from "../../common/optionsForColors";
import {formatWeekToISODate} from "../../common/formatWeekToISODate";
import {ItemNews} from "./itemNews";
import dayjs from "dayjs";
import styles from './newsComponent.module.sass'
import {EmptyComponent} from "../../common/empty";

export const NewsComponent = () => {

    const dispatch = useAppDispatch()

    const date = useAppSelector(selectDateNews)
    const news = useAppSelector(selectDataNews)
    const checkedCategories = useAppSelector(selectCategoriesNews)
    const checkedMps = useAppSelector(selectMpsNews)
    const checkedSpm = useAppSelector(selectSpmNews)
    const page = useAppSelector(selectPageNews)
    const category = useAppSelector(selectCategory)

    const weekCount = Math.round((dayjs(date[1]).valueOf() - dayjs(date[0]).valueOf()) / 604800000)  // количество недель
    const numberWeek = dayjs(date[1]).week()                                                       // номер текущей недели
    const currentYear = dayjs(date[1]).weekYear()                                                   // текущий год

    const endDate = dayjs(date[1]).valueOf()                                                       // последний день текущей недели
    const weeksArray: string[] = [`${numberWeek}_${currentYear}`]                                  // добавляем текущую неделю в массив
    let res = endDate

    for (let i = weekCount - 1; i > 0; i--) {                                                       // с каждой итерацией отнимаем неделю и складываем в массив с неделями
        res = res - 604800000
        const week = dayjs(res).week()
        const year = dayjs(res).weekYear()
        weeksArray.unshift(`${week}_${year}`)
    }

    useEffect(() => {
        dispatch(fetchParamNewsTC())
        dispatch(fetchDataNewsTC({
            from_date: date[0],
            to_date: date[1],
            category: checkedCategories,
            spm: category === 'marketplaces' ? checkedMps : checkedSpm
        }))
    }, [date, checkedCategories, checkedSpm, checkedMps, page, category]);

    const newsCategories: string[] = []     // все категории в новостях

    news.forEach((el) => {
        if (!newsCategories.includes(el.category)) {
            newsCategories.push(el.category)
        }
    })

    const limitWeek = 7                      // хардкод количества недель для отображения
    const columnWidth = window.innerWidth <= 1440 ? window.innerWidth / limitWeek : 1440 / limitWeek  // ширина столбцов
    const dataTables = useMemo(() => {
        // 1. Собираем уникальные категории
        const newsCategories = Array.from(new Set(news.map(el => el.category)));

        return newsCategories.map((cat) => {
            // Формируем колонки
            const columns = [
                {
                    key: -1,
                    title: '',
                    dataIndex: 'categoryName',
                    width: 40,
                    onCell: (_: any, index: any) => ({
                        rowSpan: index === 0 ? platformsNews.length : 0,
                    }),
                    render: () => (
                        <div className={styles.verticalCategory}>{cat}</div>
                    ),
                },
                ...weeksArray.map((week, idx) => ({
                    key: idx,
                    title: formatWeekToISODate(week),
                    dataIndex: week,
                    width: 212,
                    render: (items: any[], row: any) => (
                        <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                            {items?.map((item, i) => {
                                const color = [...marketPlacesColors, ...superMarketsColors]
                                    .find(s => s.name === row.key)?.color;
                                return <ItemNews key={i} data={item} color={color} platform={row.key}/>;
                            })}
                        </div>
                    )
                }))
            ];

            // 2. Список платформ для этой категории
            const platformsNews = Array.from(new Set(
                news.filter(el => el.category === cat).map(el => el.spm)
            ));

            // 3. Формируем DataSource
            const dataSource = platformsNews.map((pl) => {
                const row: any = {key: pl};
                weeksArray.forEach(week => {
                    row[week] = news.filter(el =>
                        el.spm === pl &&
                        el.category === cat &&
                        el.num_week === week
                    ).map(el => ({
                        get_date: el.get_date,
                        title: el.title,
                        content: el.content,
                        links: el.links
                    }));
                });
                return row;
            });

            return {columns, dataSource};
        });
    }, [news, weeksArray, checkedCategories]); // Пересчет только если изменились данные

    function CustomRow(props: any) {
        const color = marketPlacesColors.concat(superMarketsColors).find((spm) => spm.name === props['data-row-key'])
        return (
            <Tooltip title={props['data-row-key']} placement="left" color={color?.color}
                     overlayInnerStyle={{color: color?.color === lightColor ? '#000' : (['Купер'].includes(props['data-row-key']) ? '#000' : '#FFF')}}>
                <tr {...props} />
            </Tooltip>
        );
    } // для tooltip

    return (
        <div className={styles.main}>
            <div className={styles.title}>Новости</div>
            <div className={styles.tableHead}>
                {weeksArray.map((el, index) => {
                    return <div key={index} className={styles.tableItem} style={{width: '100%'}}>
                        {formatWeekToISODate(el)}
                    </div>
                })}
            </div>
            <div>
                {dataTables.length ? dataTables.map((table, index) => <div key={index}
                                                                           style={{borderBottom: '5px solid white'}}>
                    <Table
                        columns={table.columns}
                        dataSource={table.dataSource}
                        pagination={false}
                        showHeader={false}
                        bordered={false}
                        size={'small'}
                        components={{
                            body: {
                                row: CustomRow
                            }
                        }}
                    />
                </div>) : <EmptyComponent/>}
            </div>

        </div>
    );
};

